export const SHOW_LOADING = 'SHOW_LOADING';
export const HIDE_LOADING = 'HIDE_LOADING';
export const SHOW_PROGRESSIVE_LOADING = 'SHOW_PROGRESSIVE_LOADING';
export const HIDE_PROGRESSIVE_LOADING = 'HIDE_PROGRESSIVE_LOADING';
export const CHANGE_ANIMATION = 'CHANGE_ANIMATION';
export const SHOW_MAIN_MENU = 'SHOW_MAIN_MENU';
export const HIDE_MAIN_MENU = 'HIDE_MAIN_MENU';
export const CHANGE_MAIN_MENU = 'CHANGE_MAIN_MENU';
export const CHANGE_EVENT_CLICK = 'CHANGE_EVENT_CLICK';
